// Registra acessos em support/affiliateActivity/{uid}/acessos/{timestamp}.
const ROUTE_MODULES = {
  users: { key: "users", label: "Clientes" },
  cancelamentos: { key: "cancelamentos", label: "Cancelamentos" },
  reservas: { key: "reservas", label: "Reservas" },
  finance: { key: "finance", label: "Financeiro" },
  updates: { key: "updates", label: "Atualizações" },
  aplicativos: { key: "aplicativos", label: "Aplicativos" },
  "updates-analytics": { key: "updates", label: "Atualizações" },
  "new-update": { key: "updates", label: "Atualizações" },
  "edit-update": { key: "updates", label: "Atualizações" },
  "nps-surveys": { key: "nps-surveys", label: "Pesquisa NPS" },
  "new-nps-survey": { key: "nps-surveys", label: "Pesquisa NPS" },
  "edit-nps-survey": { key: "nps-surveys", label: "Pesquisa NPS" },
  "nps-responses": { key: "nps-surveys", label: "Pesquisa NPS" },
  "academy-hub": { key: "academy-hub", label: "AcademyHub" },
  "academy-hub-uso": { key: "academy-hub", label: "AcademyHub" },
  "academy-hub-content": { key: "academy-hub", label: "AcademyHub" },
  "academy-hub-lesson-new": { key: "academy-hub", label: "AcademyHub" },
  "academy-hub-lesson-edit": { key: "academy-hub", label: "AcademyHub" },
  "academy-hub-feedbacks": { key: "academy-hub", label: "AcademyHub" },
  servers: { key: "servers", label: "Servidores" },
  "proximos-eventos": { key: "proximos-eventos", label: "Próximos eventos" },
  "marketing-leads": { key: "marketing-leads", label: "Leads" },
  "marketing-business-plan": { key: "marketing-business-plan", label: "Business Plan" },
  "marketing-landing-form": { key: "marketing-landing-form", label: "Landing page" },
  "marketing-campaigns": { key: "marketing-campaigns", label: "Modais internos" },
  affiliates: { key: "affiliates", label: "MoneyHub" },
  "affiliates-dashboard": { key: "affiliates-dashboard", label: "MoneyHub" },
  "commission-plans": { key: "affiliates-plans", label: "MoneyHub" },
  "affiliates-marketing": { key: "affiliates-marketing", label: "MoneyHub" },
  monitor: { key: "monitor", label: "Monitoramento" },
  management: { key: "management", label: "Gestão" },
  "master-logs": { key: "master-logs", label: "Histórico" },
  "master-users": { key: "master-users", label: "Usuários" },
  chamados: { key: "chamados", label: "Chamados" },
  "suporte-dashboard": { key: "chamados", label: "Dashboard Suporte" },
  carteiras: { key: "relacionamento", label: "Carteiras" },
  questions: { key: "questions", label: "Perguntas Frequentes" },
  trainings: { key: "trainings", label: "Treinamentos" },
};

export function getModuleFromRoute(route) {
  if (!route?.name) return null;
  return ROUTE_MODULES[route.name] || null;
}

export function logModuleAccessIfChanged(firebase, to, from) {
  if (!window.uid || to.meta?.public) return;

  const toModule = getModuleFromRoute(to);
  if (!toModule) return;

  const fromModule = getModuleFromRoute(from);
  if (fromModule?.key === toModule.key) return;

  const timestamp = Date.now();
  const activity = {
    action: `Acesso ao módulo ${toModule.label}`,
    module: toModule.key,
    moduleLabel: toModule.label,
    routeName: to.name,
    timestamp,
  };

  firebase
    .database()
    .ref(`support/affiliateActivity/${window.uid}/acessos/${timestamp}`)
    .set(activity)
    .catch((error) => {
      console.error("Erro ao registrar acesso ao módulo:", error);
    });
}
